/** Unit appended to a points amount; omit for the bare number. `pontos` agrees in number ("1 ponto"). */
export type PointsUnit = "pts" | "pontos";

const WHOLE_POINTS = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });
const FRACTIONAL_POINTS = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function unitLabel(unit: PointsUnit, value: number): string {
  if (unit === "pts") return unit;
  return Math.abs(value) === 1 ? "ponto" : "pontos";
}

/**
 * Loyalty points in pt-BR ("1.250 pts", "12,50 pontos", "1 ponto"): whole amounts without decimals,
 * fractional amounts with two, so no earned fraction is hidden.
 */
export function formatPoints(value: number, unit?: PointsUnit): string {
  const cents = Number.isFinite(value) ? Math.round(value * 100) : 0;
  const amount = cents / 100;
  const text = cents % 100 === 0 ? WHOLE_POINTS.format(amount) : FRACTIONAL_POINTS.format(amount);
  return unit ? `${text} ${unitLabel(unit, amount)}` : text;
}
